export const FORM_VALIDATOR_EMAIL_PATTERN = '^[aA-zZ0-9._%+-]+@[aA-zZ0-9.-]+\\.[aA-zZ]{2,4}$';
export const FORM_VALIDATOR_NOM_DETENU_MAX_LENGTH = 40;
export const FORM_VALIDATOR_PRENOM_DETENU_MAX_LENGTH = 25;
export const FORM_VALIDATOR_NUMERO_ECROU_PATTERN = '^[0-9]{1,7}$';
export const FORM_VALIDATOR_NUMERO_ECROU_MAX_LENGTH = 7;
export const FORM_VALIDATOR_NOM_VISITEUR_MAX_LENGTH = 40;
export const FORM_VALIDATOR_PRENOM_VISITEUR_MAX_LENGTH = 40;
export const FORM_VALIDATOR_PERMIS_VISITE_MAX_LENGTH = 8;
